<template>
    <iframe :src="iframeSrc" style="height: 100vh; width: 100vw;"></iframe>
  </template>
  
  <script>
  export default {
    data() {
      return {
        iframeSrc: '',
      };
    },
    created() {
      this.iframeSrc = `/aliff/thankyou.html`;
    },
  };
  </script>
  
  <style>
  ::-webkit-scrollbar {
    display: none;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/partials/ThankyouPage.vue